// Shim Ember module
export default self.Ember;
